import React, { createContext, useState } from "react";

export const LayoutFlagContext = createContext();

export const LayoutFlagProvider = (props) => {
    const {children} = props;//propsとしてchildrenを受け取る
    const [layoutMode, setLayoutMode] = useState('initial');
    return(
        <LayoutFlagContext.Provider value={{layoutMode, setLayoutMode}}>
            {children}
        </LayoutFlagContext.Provider>
    );
};